import React, { createContext, useContext, useEffect, useState } from 'react';

const WholesaleCartContext = createContext();

export const useWholesaleCart = () => {
    const context = useContext(WholesaleCartContext);
    if (!context) {
        throw new Error('useWholesaleCart must be used within a WholesaleCartProvider');
    }
    return context;
};

export const WholesaleCartProvider = ({ children }) => {
    const [items, setItems] = useState(() => {
        const saved = localStorage.getItem('wayside-wholesale-cart');
        return saved ? JSON.parse(saved) : [];
    });

    useEffect(() => {
        localStorage.setItem('wayside-wholesale-cart', JSON.stringify(items));
    }, [items]);

    const addItem = (product, quantity = 1) => {
        setItems(prev => {
            const existing = prev.find(item => item.product.id === product.id);
            if (existing) {
                return prev.map(item => item.product.id === product.id ? { ...item, quantity: item.quantity + quantity } : item);
            }
            return [...prev, { product, quantity }];
        });
    };

    const updateQuantity = (productId, quantity) => {
        if (quantity <= 0) {
            setItems(prev => prev.filter(item => item.product.id !== productId));
            return;
        }
        setItems(prev => prev.map(item => item.product.id === productId ? { ...item, quantity } : item));
    };

    const removeItem = (productId) => {
        setItems(prev => prev.filter(item => item.product.id !== productId));
    };

    const clearCart = () => setItems([]);

    const itemCount = items.reduce((sum, item) => sum + item.quantity, 0);
    const total = items.reduce((sum, item) => sum + (Number(item.product.wholesale_price || 0) * item.quantity), 0);

    return (
        <WholesaleCartContext.Provider value={{ items, addItem, updateQuantity, removeItem, clearCart, itemCount, total }}>
            {children}
        </WholesaleCartContext.Provider>
    );
};
